import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertItem, AlertType, User } from 'src/app/core/models';
import { AlertService, ModalService, UserService } from 'src/app/core/services';
import { BaseModal } from 'src/app/core/utils/BaseModal';

@Component({
  selector: 'app-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.sass']
})
export class ChangePasswordModalComponent extends BaseModal implements OnInit {
  public changePasswordForm: FormGroup;
  public invalidPassword = false;
  public isValid = false;
  public initialState: User;
  public user: User;
  public promise: Promise<any>;
  public specialCharacter = false;
  public uppercaseCharacter = false;
  public minCharacterValid = false;
  public hasNumber = false;
  public loading = false;
  public errorMessage: string;
  public passwordMismatch = false;

  get lastState() {
    return null;
  }

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private userService: UserService,
    modalService: ModalService
  ) {
    super(modalService);
  }

  ngOnInit() {
    this.user = this.initialState;
    this.createForm();
  }

  createForm(): void {
    this.changePasswordForm = this.formBuilder.group({
      password: ['', [Validators.required]],
      passwordConfirmation: ['', [Validators.required]],
      oldPassword: ['', [Validators.required]]
    });
    this.changePasswordForm.get('password').valueChanges.subscribe(value => {
      const regexSpecialCharacter = /\W|_/;
      const regexUppercase = /[A-Z]/;
      const regexHasNumber = /[0-9]/;
      this.specialCharacter = regexSpecialCharacter.test(value);
      this.uppercaseCharacter = regexUppercase.test(value);
      this.hasNumber = regexHasNumber.test(value);
      if (value.length >= 10) {
        this.minCharacterValid = true;
      } else {
        this.minCharacterValid = false;
      }
    });
    this.changePasswordForm.get('oldPassword').valueChanges.subscribe(() => {
      this.errorMessage = '';
    });
    this.changePasswordForm.valueChanges.subscribe(() => {
      this.isValid = false;
      const oldPassword = this.changePasswordForm.get('oldPassword').value;
      const password = this.changePasswordForm.get('password').value;
      const passwordConfirmation = this.changePasswordForm.get('passwordConfirmation').value;
      this.passwordMismatch = password && passwordConfirmation && password !== passwordConfirmation;
      if (oldPassword != null && password === passwordConfirmation &&
        this.minCharacterValid && this.uppercaseCharacter && this.specialCharacter && this.hasNumber) {
        this.isValid = this.changePasswordForm.valid;
      }
    });
  }

  public async onAllSubmited() {
    if (!this.isValid) { return; }
    const email = this.user.email;
    const oldPassword = this.changePasswordForm.get('oldPassword').value;
    const newPassword = this.changePasswordForm.get('password').value;
    const confirmPassword = this.changePasswordForm.get('passwordConfirmation').value;


    try {
      this.loading = true;
      const response = await this.userService.updatePassword({
        email,
        oldPassword,
        newPassword,
        confirmPassword
      });
      this.alertService.show(new AlertItem('PasswordSaved', AlertType.success));
      setTimeout(() => {
        this.onClose();
      }, 1000);
    } catch (error) {
      this.alertService.show(new AlertItem('PasswordSaveError', AlertType.danger));
      this.errorMessage = error.error?.message || '';
    } finally {
      this.loading = false;
    }
  }
}
